import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { RootState } from '../../store';
import { Iam } from "@smash-sdk/iam/ejs/10-2019";
import { AsyncState } from '../../shared/models/async.interface';




interface UpdatedPasswordState extends AsyncState {
    currentPassword: string | null,
    newPassword: string | null,
}

export interface PasswordState {
    updatedPassword: UpdatedPasswordState
}


interface PasswordInput {
    currentPassword: string,
    newPassword: string,
}

export const updatePassword = createAsyncThunk(
    'password/updatePassword',
    async (password: PasswordInput, thunkApi) => {
        try {
            const iamSdk = new Iam()
            return await iamSdk.updatePassword(password);
        } catch (error: any) {
            return thunkApi.rejectWithValue({ ...error });
        }
    }
);


export const initialState: PasswordState = {
    updatedPassword: {
        currentPassword: null,
        newPassword: null,
        isLoading: false,
        isSuccess: false,
        isError: false,
        error: undefined,
    },
}

export const passwordSlice = createSlice({
    name: 'password',
    initialState,
    reducers: {
        resetUpdatedPassword: (state) => {
            state.updatedPassword = {
                currentPassword: null,
                newPassword: null,
                isLoading: false,
                isSuccess: false,
                isError: false,
                error: undefined,
            };
        },
    },
    extraReducers: (builder) => {
        builder
            // UPDATE PASSWORD
            .addCase(updatePassword.pending, (state) => {
                state.updatedPassword.isLoading = true;
                state.updatedPassword.isError = false;
                state.updatedPassword.error = undefined;
            })
            .addCase(updatePassword.fulfilled, (state) => {
                state.updatedPassword.isLoading = false;
                state.updatedPassword.isSuccess = true;
            })
            .addCase(updatePassword.rejected, (state, action) => {
                state.updatedPassword.isLoading = false;
                state.updatedPassword.isError = true;
                state.updatedPassword.error = action.error;
            })
    }
});



export const { resetUpdatedPassword } = passwordSlice.actions;

export const passwordState = (state: RootState) => state.password;

export default passwordSlice.reducer;